import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import Badge from "../../components/badge/Badge";
import Footer from "../../components/footer/Footer";
import Navigation from "../../components/navigation/Navigation";
import { ENDPOINT, getJWT } from "../../helpers/Helper";
import "./orders.css";

const RenderLoading = () => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <Spinner animation="border" variant="darke" />
  </div>
);

function Orders() {
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState();
  const [orderAvailable, setOrderAvailable] = useState(false);

  // const thumbnail = orders && orders.products.map(product => product);

  // console.log(thumbnail && thumbnail[0].imageUrl);

  useEffect(() => {
    window.scrollTo(0, 0);

    setLoading(true);

    const jwt = getJWT();

    axios
      .get(`${ENDPOINT}/orders/completed`, {
        headers: { Authorization: `Bearer ${jwt}` },
      })
      .then((res) => {
        setOrders(res && res.data.data);
        setOrderAvailable(true);
        setLoading(false);
      })
      .catch((err) => {
        toast(`Oops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setOrderAvailable(false);
        setLoading(false);
      });
  }, []);

  return (
    <div className="orders">
      <Navigation
        background="theme-color"
        logo="https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png"
      />

      <div className="section_1">
        {orders && loading ? (
          RenderLoading()
        ) : (
          <div className="card_wrapper">
            <div className="border_wrapper">
              <h3>Orders</h3>
            </div>

            {orderAvailable ? (
              <React.Fragment>
                {orders &&
                  orders.map((item) => (
                    <Row className="delivery" key={item._id}>
                      <Col
                        md={3}
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <img
                          src={item.products[0] && item.products[0].imageUrl}
                          alt=""
                          className="product_img"
                        />
                      </Col>
                      <Col md={9}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <h4>
                            {item.products.map((product) => (
                              <span>{`${product.productName}, `}</span>
                            ))}
                          </h4>
                          {/* <Link to="/" className='see_details' >SEE DETAILS</Link> */}
                        </div>

                        <p>{`Order no. ${item.paymentId}`}</p>

                        <Badge content={item.status} />

                        <h5 style={{ marginTop: "1rem" }}>{`Kshs ${
                          item && item.totalAmount.toLocaleString()
                        }.00`}</h5>

                        <p>{`On ${item.completedAt}`}</p>
                      </Col>
                    </Row>
                  ))}
              </React.Fragment>
            ) : (
              <div className="delivery">
                <h1>You don't have any orders</h1>
              </div>
            )}
          </div>
        )}
      </div>

      <Footer />

      <ToastContainer />
    </div>
  );
}

export default Orders;
